import "./add.css"
import { useContext, useEffect, useState } from 'react';
import { Form, Input, Button, message, Select } from "antd";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ItemService } from '../../services/Item';
import TableForm from "./tableForm";
import QuillEditor from "../quillEditor/quillEditor";
import { Tool, ToolService } from "../../services/Tool";
import { ItemsContext } from "../../layout/itemContext/itemContext";


function ItemAdd() {

    const navigate = useNavigate();
    const { state } = useLocation();
    const [itemType, setItemType] = useState(state?.itemType)
    const [form] = Form.useForm();
    const params = useParams();
    const [tools, setTools] = useState<Tool[]>([]);
    const country = params.country;
    const { getTitles } = useContext(ItemsContext);

    useEffect( () => {
        const getTools = async () => {
            const {data} = await ToolService.getAll(params.country)
            setTools(data)
        }
        getTools();
        
    }, [params.country])


    const save = async (values: any) => {
        const { data } = await ItemService.create({ ...values, parent: state?.parent, country, itemType });
        message.success('New Item added');
        await getTitles();
        navigate(`/${country}/${data._id}/`, { replace: true });
    };

    return (
        <div className='wrapper'>
            <h1>Add Item</h1>
            <Select value={itemType} onChange={setItemType} style={{width:'100%', marginBottom: 16}} placeholder="Please select type of Item">
                <Select.Option value='content'>Text Item</Select.Option>
                <Select.Option value='table'>Table Item</Select.Option>
            </Select>
            {itemType === 'content' && <QuillEditor />}
            {itemType === 'table' && <Form
                name="basic"
                form={form}
                onFinish={save}
                scrollToFirstError={true}
                className='add-item'
                layout="vertical"
                style={{padding:0}}
            >
                <Form.Item name="title" label="Title" >
                    <Input />
                </Form.Item>
                <TableForm name='tablePlanning' title='Planning and Preparatory stage' tools={tools}/>
                <TableForm name='tableBids' title='Bids Solicitation' tools={tools}/>
                <TableForm name='tableEvaluation' title='Evaluation' tools={tools}/>
                <TableForm name='tableCommitteeReview' title='Committee Review' tools={tools}/>
                <TableForm name='tableContractAward' title='Contract Award' tools={tools}/>
                <TableForm name='tableContractManagement' title='Contract Management' tools={tools}/>
                
                <Form.Item>
                    <Button type="primary" htmlType="submit" className="form-submit-button">
                        SAVE
                    </Button>
                </Form.Item>
            </Form>
            }
        </div>

    );
}

export default ItemAdd;